<template>
  <div>
    <b-row>
      <b-col cols="12" lg="4" xl="3">
        <div class="card mb-0">
          <div class="card-header">
            <div ref="menuHead">
              <b-list-group>
                <b-list-group-item>
                  <center>
                    <h6 class="m-0">{{ project.name }}</h6>
                    <b-btn
                      id="in-step-0"
                      variant="link"
                      @click="tourStart()"
                      class="p-1 text-info"
                      style="position: absolute; right: 5px; top: 0px"
                      ><i class="fa fa-question-circle fa-2x m-0" aria-hidden="true"></i
                    ></b-btn>
                  </center>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b-btn to="/" class="mr-1" size="sm" v-b-tooltip.hover title="Назад"
                    ><i class="fa fa-arrow-left fa-lg"></i></b-btn
                  ><span class="pull-right">
                    <b-btn
                      v-b-modal.editProject
                      class="ml-1"
                      v-b-tooltip.hover
                      size="sm"
                      variant="primary"
                      title="Настройки проекта"
                      ><i class="fa fa-cog fa-lg"></i
                    ></b-btn>
                  </span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center" ref="buttonsArea">
                  <div></div>
                  <b-button-group class="pull-right m-0">
                    <b-btn variant="primary" v-if="1 !== 1">
                      <b-progress :max="100">
                        <b-progress-bar :value="100" label="Моделирование..." animated></b-progress-bar>
                      </b-progress>
                    </b-btn>
                    <b-btn
                      v-else
                      variant="success"
                      size="sm"
                      @click="calculate()"
                      v-b-tooltip.hover
                      title="Выполнить расчет"
                      ><i class="fa fa-play fa-lg"></i
                    ></b-btn>
                  </b-button-group>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div class="components scroll-container p-2" ref="components">
              <hr class="my-1" />
              <span ref="componentsButtons">
                <span class="text-center"> </span>
              </span>
              <hr class="my-1" />
              <center>
                <button
                  v-b-modal.editRoom
                  @click="cur_room = {}"
                  v-b-tooltip.hover
                  title="Добавить помещение"
                  style="margin-left: -2.3rem"
                  class="p-0 btn btn-primary btn-icon waves-effect waves-light mb-2"
                >
                  <i style="margin: -1px" class="fa fa-plus img-30 mr-0"></i>
                </button>
              </center>

              <ul class="tree pt-2" v-if="project.rooms && project.rooms.length > 0">
                <li v-for="(person, p_index) in project.rooms" :key="person.id">
                  <input
                    v-if="person.mapObjects && person.mapObjects.length > 0"
                    type="checkbox"
                    ref="toogleCheckbox"
                    :id="'p' + p_index"
                  />

                  <label
                    :for="'p' + p_index"
                    class="tree_label"
                    style="padding-bottom: 10px"
                    v-bind:class="{ empty: !person.mapObjects || person.mapObjects.length == 0 }"
                  >
                    <b-row>
                      <b-col sm="auto" class="pr-0 pl-4" style="margin-top: -12px">
                        <dropdown
                          :close-on-click="true"
                          @click.prevent
                          v-bind:class="cur_room && cur_room.id && person.id == cur_room.id ? 'activeElement' : ''"
                          ref="peopleDropdown"
                        >
                          <template slot="btn">
                            <img
                              @click.stop="
                                cur_room = person;
                                return;
                              "
                              @contextmenu.prevent="$refs.peopleDropdown[p_index]._onToggle($event)"
                              src="../../assets/icons/engineer123.png"
                              class="img-radius grabbable"
                              style="height: 30px; width: 30px; margin-left: 0px"
                            />
                          </template>
                          <template slot="body">
                            <ul>
                              <li
                                style="cursor: pointer"
                                @click="
                                  cur_room = person;
                                  roomEdit();
                                "
                              >
                                <i class="fa fa-edit"></i> Изменить
                              </li>
                              <li
                                style="cursor: pointer"
                                @click.prevent="
                                  $refs.remove_modal.index = p_index;
                                  $refs.remove_modal.room_id = person.id;
                                "
                                v-b-modal.remove_modal
                              >
                                <i class="fa fa-remove text-danger"></i> Удалить
                              </li>
                            </ul>
                          </template>
                        </dropdown>
                      </b-col>
                      <b-col style="margin-top: -9px">
                        <b>{{ person.name }}</b>
                        <p class="text-muted m-b-0 font-size-11">
                          Площадь: <b>{{ person.S }}</b>
                        </p>
                        <p class="text-muted m-b-0 font-size-11">
                          Высота: <b>{{ person.H }}</b>
                        </p>
                      </b-col>
                    </b-row>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-col>
      <!--  acttivity and feed start -->

      <b-col cols="12" lg="8" xl="9" class="p-0 pr-3">
        <div class="card latest-activity-card" ref="mapArea" style="overflow-y: auto">
          <div class="card-block p-0">
            <cells :room.sync="cur_room" :project.sync="project"></cells>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal id="editProject" ref="editProject" hide-footer title="Настройки">
      <newBuilding @hideWindow="$refs.editProject.hide()" :project.sync="project"></newBuilding>
    </b-modal>
    <div v-html="result"></div>
    <b-modal id="editRoom" ref="editRoom" hide-footer title="Добавить помещение">
      <newRoom @hideWindow="$refs.editRoom.hide()" :room.sync="cur_room" :project.sync="project"></newRoom>
    </b-modal>
    <b-modal ref="remove_modal" hide-footer id="remove_modal" title="Удалить">
      <div class="d-block text-center">
        <h3>Вы действительно хотите удалить это помещение?</h3>
      </div>
      <b-btn
        class="mt-3 btn-outline"
        variant="danger"
        block
        @click="
          roomRemove($refs.remove_modal.room_id, $refs.remove_modal.index);
          $refs.remove_modal.hide();
        "
        >Удалить
      </b-btn>
    </b-modal>
  </div>
</template>
<style>
fieldset {
  border: unset !important;
}
.activeElement {
  background-color: #207be5;
}
</style>
<script>
import Dropdown from "bp-vuejs-dropdown";
import newBuilding from "./new_building";
import newRoom from "./new_room";
import cells from "./cells";
export default {
  name: "Risk",
  data() {
    return {
      project: {},
      fields: [
        // A regular column
        { key: "name", label: "Название помещения" },
        { key: "S", label: "Площадь" },
        { key: "H", label: "Высота" },
        { key: "action", label: "Действия" },
      ],
      cur_room: {},
      result: null,
    };
  },
  components: {
    Dropdown,
    newBuilding,
    newRoom,
    cells,
  },
  created() {
    this.fetchData();
  },
  mounted: function () {
    this.menuHeadHeight = this.$refs.menuHead.clientHeight;
    this.menuHeadTimer = setInterval(() => {
      if (this.menuHeadHeight != this.$refs.menuHead.clientHeight) {
        this.menuHeadHeight = this.$refs.menuHead.clientHeight;
        this.matchHeight();
      }
    }, 500);
    this.matchHeight();
    window.addEventListener("resize", this.matchHeight);
  },
  beforeDestroy: function () {
    clearInterval(this.menuHeadTimer);
  },
  methods: {
    matchHeight() {
      this.$refs.components.style.height =
        document.documentElement.clientHeight - this.$refs.components.getBoundingClientRect().top - 40 + "px";
      this.$refs.mapArea.style.height =
        document.documentElement.clientHeight - this.$refs.mapArea.getBoundingClientRect().top - 20 + "px";
      var height = document.documentElement.clientHeight - this.$refs.mapArea.getBoundingClientRect().top;
      this.$refs.map.height = height;
      this.$refs.map.matchHeight();
      if (this.$refs.buttonsArea && this.$refs.buttonsArea.clientWidth < 355) {
        this.toogleButtons = true;
      } else {
        this.toogleButtons = false;
      }
      if (this.$refs.mapArea && this.$refs.mapArea.clientWidth < 1100) {
        this.toogleButtonsMap = true;
      } else {
        this.toogleButtonsMap = false;
      }
    },
    fetchData() {
      this.loading = true;
      this.$http
        .get("category/buildings/open?id=" + this.$route.params.id)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.project = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    calculate() {
      this.$http
        .get("category/buildings/calc?building_id=" + this.$route.params.id)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.result = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    roomEdit() {
      this.$refs.editRoom.show();
    },
    roomRemove(id, index) {
      this.$http
        .post("category/rooms/remove?id=" + id)
        .then(() => {
          this.project.rooms.splice(index, 1);
          if (this.cur_room.id == id) {
            this.cur_room = {};
          }
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
  },
};
</script>
